import React from 'react';
import { Button } from '../../../ui-kit';












export default function ShareVideoLinkButton({
  prefix,
  disabled,
  className,
  tooltipId,
  tooltipLabel,
  onClick,
  dataCy,
  children
}) {
  return (
    <Button
      type="TERTIARY"
      disabled={disabled}
      prefix={prefix}
      className={className}
      tooltipId={tooltipId}
      tooltipLabel={tooltipLabel}
      data-cy={dataCy}
      onClick={onClick}>

      {children}
    </Button>);

}